import React from 'react';
import {translate,isValidRange} from 'utils/common';
// import PasswordField from './passwordfield';
import FormMsg from './formmessage';
import Validator from 'validator';

function getField(props,validator)
{
    let fieldClassName = props.fieldClassName || 'form-control';
    let extraPops = props.extraPops || {};
    let p = {id: (props.id || (props.name+new Date().getTime())),
             name:(props.nameAlias || props.name),
             //onChange:props.onChange,
             disabled:!!props.disabled,
             value:(props.value || ''),
             className:(fieldClassName+" "+(validator.isInvalid && 'is-invalid')),
             placeholder:translate(props.placeholder || ''),
             ...extraPops
            }
    props.onChange && (p['onChange'] = props.onChange);
    props.onKeyPress && (p['onKeyPress'] = props.onKeyPress);
    props.onBlur && (p['onBlur'] = props.onBlur);
    props.onClick && (p['onClick'] = props.onClick);
    let type = props.type || 'text';
    switch(props.type)
    {
        case 'textarea': props.rows && (p['rows'] = props.rows);
                         return <textarea {...p}></textarea>
        // case 'password': return <PasswordField type={type} validatorToolTip={!!props.validatorToolTip}
        //     {...(props.rules || {})}
        //     hideShowPassword={!!props.hideShowPassword} {...p} p={p}/>                 
        case 'radio': 
        case 'checkbox': p['checked'] = !!props.checked;
        default: return <input type={type} {...p}/>
    }
}


export class Number extends React.Component{
    constructor(props)
    {
        super(props);
        this.changeHandler = this.changeHandler.bind(this);
        this.id = this.props.id || ('number-'+this.props.name+'-'+new Date().getTime());
        this.setProps();
        this.state = {};
        this.valueChangable = !!this.props.onChange;
        this.validValue = this.props.value || this.p.defaultValue;
    }
    setProps(){
        let extraPops = this.props.extraPops || {};
        this.p = {...this.props,type:'text',onChange:this.changeHandler,...extraPops,value : this.props.value || this.props.defaultValue || '',id:this.id};
    }
    changeHandler(event)
    {
        const value = event.target.value;
        const field = event.target.name;
        if(value && !Validator.isNumeric(value)){
            this.setState({changed:true});
            return;
        }
        this.p.value = value;
        this.setState({value:value});
        if(this.p.min!=undefined || this.p.max!=undefined){
            this.processing = true;
            this.validationTimer && clearTimeout(this.validationTimer);
            this.validationTimer = null;
            let res = isValidRange(value,this.p.min,this.p.max,(valid,pvalue)=>{
                let v = parseFloat(value);
                //console.log(value+'-----vvv-----'+pvalue);
                if(!valid){
                    v = (this.p.emptyValue ? "" : parseFloat(this.p.defaultValue || this.validValue));
                }
                else{
                    this.validValue = value;
                }
                this.p.value = v;
                this.setState({value:v},()=>this.processing=false);
                this.props.onChange && this.props.onChange(event,field,v);
            });
            this.validationTimer = res.timer;
            res.valid && this.props.onChange && this.props.onChange(event,field,res.value);
        }
        else{
            this.props.onChange && this.props.onChange(event,field,value);
        } 
    }
    componentDidUpdate()
    {
        //console.log(this.p.value +' -- '+this.props.value);
        if(!this.processing && this.valueChangable && this.p.value!=this.props.value && !isNaN(this.props.value))
        {
            this.p.value = this.props.value;
            this.setState({value:this.p.value});
        }
        this.setProps();
    }
    render(){
        const props = this.p;
        const validator = (props.validator && props.validator[props.name]) || {isInvalid:false};        
        return(
            <React.Fragment>
                {getField(props,validator)}
                <FormMsg htmlFor={props.name} error={translate(validator.message ||'')}/>
            </React.Fragment>
      )
    }
}

export class Input extends React.PureComponent{
    render(){
        const props = this.props;
        const validator = (props.validator && props.validator[props.name]) || {isInvalid:false};        
        return(
            <React.Fragment>
                {getField(props,validator)}
                <FormMsg htmlFor={props.name} error={translate(validator.message ||'')}/>
            </React.Fragment>
      )
    }
};

